import { toast as reactToast } from 'react-toastify';

type Props = {
  type: 'SUCCESS' | 'ERROR';
  text: string;
  id?: string;
};

const toast = ({ type, text, id = text }: Props) => {
  if (type === 'SUCCESS') reactToast.success(text, { toastId: id });
  else if (type === 'ERROR') reactToast.error(text, { toastId: id });
};
export default toast;
